<template>
  <div>
    <div>
      <el-row :gutter="12">
        <el-col :span="24">
          <div style="width: 100%;text-align: right;">
            <el-select v-model="condition.typeCode" style="width: 120px;">
              <el-option label="全部类别" value></el-option>
              <el-option label="设备故障" value="设备故障"></el-option>
            </el-select>
            <el-select
              style="width: 110px;margin-left: 3px;"
              v-model="condition.statuses"
              placeholder="请选择"
            >
              <el-option label="全部状态" value></el-option>
              <el-option label="待处理" value="1"></el-option>
              <el-option label="已跟进" value="2"></el-option>
              <el-option label="已解决" value="3"></el-option>
              <el-option label="已忽略" value="4"></el-option>
            </el-select>
            <el-input
              type="text"
              style="width:255px;margin-left: 3px;"
              v-model="condition.searchx"
              placeholder="支持姓名，手机号或者SN搜索"
            ></el-input>
            <el-button
              type="primary"
              style="margin-left: 3px;"
              icon="el-icon-search"
              @click="condition.pageId=1;getTableData()"
            >搜索</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="margin-top: 15px;">
      <el-table
        ref="multipleTable"
        :data="tableData"
        style="width: 100%"
        element-loading-text="数据正在加载中"
        :header-cell-style="headClass"
        :row-style="rowClass"
      >
        <el-table-column type="selection" width="60"></el-table-column>
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="phone" label="联系电话"></el-table-column>
        <el-table-column prop="sn" label="设备SN"></el-table-column>
        <el-table-column prop="typeCode" label="类别"></el-table-column>
        <el-table-column prop="status" label="状态" :formatter="statusDescForRow"></el-table-column>
        <el-table-column prop="posttime" label="日期" :formatter="dateFormat"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <button @click="showDetail(scope.row)">详情</button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        style="text-align:right;margin-top: 15px;margin-bottom: 65px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="condition.pageId"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="condition.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
      <el-dialog :visible.sync="detailVisible" title="详情" :close-on-click-modal="false">
        <el-form label-position="right" label-width="100px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="设备SN：">{{ detail.sn }}</el-form-item>
              <el-form-item label="姓名：">{{ detail.name }}</el-form-item>
              <el-form-item label="类别：">{{ detail.typeCode }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态：">{{ statusDesc(detail.status) }}</el-form-item>
              <el-form-item label="联系方式：">{{ detail.phone }}</el-form-item>
              <el-form-item label="反馈日期：">{{ getStandardDate(new Date(detail.posttime)) }}</el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="描述：">{{ detail.description }}</el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="图片：">
                <el-image
                  class="detail-image"
                  style="margin-right:10px"
                  :src="url"
                  :preview-src-list="images"
                  v-for="url in images"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="text-align: right;">
              <el-button type="primary" @click="addWorkOrder">生成工单</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
      <work-form
        ref="form"
        :model="mdl"
        :dialogShow="dialogShow"
        :loading="workOrderLoading"
        @cancel="handleCancel"
        @submit="handleOk"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import workForm from '../../components/workForm/workForm'

export default {
  name: "feedbackMng.vue",
  components: {
    workForm
  },
  data () {
    return {
      tableData: [],
      condition: {
        typeCode: '',
        statuses: '',
        searchx: '',
        pageId: 1,
        size: 10
      },
      total: 0,
      detailVisible: false,
      detail: {},
      images: [],
      dialogShow: false,
      workOrderLoading: false,
      mdl: null,
      edit: false
    }
  },
  mounted () {
    this.getTableData();
  },
  methods: {
    statusDescForRow (row, column) {
      return this.statusDesc(row.status);
    },
    statusDesc (status) {
      if (status == 1) {
        return '待处理'
      } else if (status == 2) {
        return '已跟进'
      } else if (status == 3) {
        return '已解决'
      } else if (status == 4) {
        return '已挂起'
      } else {
        return '未知'
      }
    },
    handleSizeChange (val) {
      this.condition.size = val;
      this.getTableData();
    },
    handleCurrentChange (val) {
      this.condition.pageId = val;
      this.getTableData();
    },
    headClass ({
      row,
      rowIndex
    }) {
      if (rowIndex == 0) {
        return ''
      }
      return ''
    },
    rowClass ({
      row,
      rowIndex
    }) {
      if (rowIndex % 2 == 0) {
        return 'background:#F1F2F7;'
      } else {
        return 'background:white;'
      }
      return ''
    },
    getTableData () {
      var thiz = this;
      const loading = this.$loading({
        lock: true,
        text: '获取表格数据中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(() => {
        loading.close();
      }, 3000);
      axios.get(this.$store.getters.getApiValue + '/maintain/listFeedback.do', {
        params: this.condition
      }).then(function (response) {
        loading.close();
        var data = response.data;
        if (data.status == "200") {
          thiz.total = data.totalCount;
          thiz.tableData = data.data;
        } else {
          thiz.$message.error(data.message);
        }
      }).catch(function (error) {
        loading.close();
        thiz.$message.error("系统异常，请与管理员联系!");
        console.log(error);
      });
    },

    showDetail (detail) {
      this.detail = detail;
      this.images = JSON.parse(this.detail.params).images;

      this.detailVisible = true;
    },

    dateFormat (row, column, cellValue, index) {
      var str = cellValue;
      if (str == null || str == "") {
        return "";
      } else {
        return this.getStandardDate(new Date(str));
      }
    },
    getStandardDate (val) {
      var year = val.getFullYear();
      var month = val.getMonth() + 1;
      var day = val.getDate();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      return year + "-" + month + "-" + day;
    },

    // 生产工单
    addWorkOrder () {
      this.detailVisible = false
      this.dialogShow = true
      this.edit = false
      var type = this.detail
      type['typeCode'] = '反馈'
      type['matterCategory'] = 3
      this.mdl = type
    },

    handleOk (isPass, values, edit) {
      var thiz = this;
      this.workOrderLoading = true
      if (isPass) {
        // 新增
        var param = values
        if (!edit) {
          //   param['fbid'] = 0
          //   param['nid'] = this.nid
          console.log('上传数据', values)
          new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve()
            }, 1000)
          }).then(res => {
            var url = '/maintain/addTicket.do';
            axios.get(this.$store.getters.getApiValue + url, {
              params: param
            }).then(function (response) {
              var data = response.data;
              if (data.status == "200") {
                thiz.$message.success('新增成功!');
                thiz.getTableData();
                thiz.dialogShow = false
              } else {
                thiz.$message.error(data.message);
              }
            }).catch(function (error) {
              console.log(error);
              thiz.$message.error("系统异常!请与管理员联系!");
            }).finally(() => {
              thiz.workOrderLoading = false
            });
          })
        } else {
          //   param['fbid'] = 1
        }
      } else {
        console.log('submit error')
        this.$message.error("填写不完整或格式不正确，请确认！")
        this.workOrderLoading = false
      }
    },

    handleCancel () {
      this.dialogShow = false
    },

  }
}
</script>

<style scoped>
.detail-image {
  width: 120px;
  height: 120px;
}

.el-table {
  font-size: 12px;
  border-bottom: 1px solid #dcd8d8;
  color: black;
}

.el-table tr th {
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
}

.el-table tr td {
  border-bottom: 1px solid #dcd8d8;
}

.cardDivClass .el-card__header {
  padding-top: 8px;
  padding-bottom: 8px;
}

.cardDivClass .el-card__body {
  padding-top: 15px;
  padding-bottom: 20px;
}

.detailtd {
  font-weight: bold;
}

.log-div {
  height: 470px;
}

.log-li {
  width: 100%;
  /*color: ;*/
  /*text-align: center;*/
  border-bottom: solid #85ce61 1px;
}
</style>
